// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"smart-home-panel_productcontent__pG8Dl"};